import { render, staticRenderFns } from "./SubzoneForm.vue?vue&type=template&id=20c03a70"
import script from "./SubzoneForm.vue?vue&type=script&lang=js"
export * from "./SubzoneForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports